'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ToggleChoice = _react2['default'].createClass({
    displayName: 'ToggleChoice',
    handleClick: function handleClick() {
        this.props.handleSelection(this.props.value);
    },
    render: function render() {
        var classes = (0, _classnames2['default'])({
            'small-6': true,
            'columns': true,
            'm-toggle--choice': true,
            'is-active': this.props.isActive,
            'is-inactive': !this.props.isActive
        });

        return _react2['default'].createElement(
            'div',
            { className: classes, onClick: this.handleClick },
            this.props.name
        );
    }
});

var Toggle = _react2['default'].createClass({
    displayName: 'Toggle',


    propTypes: {
        initialSelection: _react2['default'].PropTypes.string
    },

    getInitialState: function getInitialState() {
        var selected = this.props.choices[0].value;
        if (this.props.initialSelection) {
            for (var i = 0; i < this.props.choices.length; i++) {
                if (this.props.initialSelection == this.props.choices[i].value) {
                    selected = this.props.choices[i].value;
                    break;
                }
            }
        }
        return { selected: selected };
    },
    handleSelection: function handleSelection(selected) {
        this.setState({ 'selected': selected });
        this.props.onSelection(selected);
    },
    renderChoice: function renderChoice(choice, i) {
        var isEventbrite = this.props.isEventbrite;
        var selected = this.state.selected;
        var value = choice.value,
            name = choice.name;

        var isActive = selected === value;

        name = isEventbrite && name === 'ANNUAL' ? 'ANNUAL - SAVE 20%!' : name;

        var props = {
            key: i,
            value: value,
            name: name,
            isActive: isActive,
            handleSelection: this.handleSelection
        };

        return _react2['default'].createElement(ToggleChoice, props);
    },
    render: function render() {
        var isEventbrite = this.props.isEventbrite;

        var classes = (0, _classnames2['default'])({
            'small-12': true,
            'small-centered': true,
            'large-3': !isEventbrite,
            'large-4': isEventbrite,
            'large-centered': true,
            'columns m-toggle': true
        });
        var choices = this.props.choices.map(this.renderChoice);
        return _react2['default'].createElement(
            'div',
            { className: classes },
            choices
        );
    }
});

exports.Toggle = Toggle;
exports.ToggleChoice = ToggleChoice;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/toggle.jsx
 ** module id = 1086
 ** module chunks = 0
 **/